import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FilterSearchingRegEntidadAuditoraViewModel, RegEntidadAuditoraViewModel, RegCampaniaEntidadAuditoraViewModel } from './entidadauditora.types';
import { UsuarioViewModel } from '../../usuarios/usuarios.types';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';

@Injectable()
export class EntidadAuditoraService extends ResetFiltersService {
    public currentFilter = new FilterSearchingRegEntidadAuditoraViewModel();

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    getEntidadAuditora(id: number): Observable<RegEntidadAuditoraViewModel> {
        return this.http.get<RegEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/' + id).pipe();
    }

    createEntidadAuditora(entidad: RegEntidadAuditoraViewModel): Observable<any> {
        return this.http.post<RegEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora', entidad).pipe();
    }

    editEntidadAuditora(entidad: RegEntidadAuditoraViewModel): Observable<any> {
        return this.http.put<RegEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora', entidad).pipe();
    }

    //deleteEntidadAuditora(id: number): Observable<any> {
    //    return this.http.delete<RegEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/' + id).pipe();
    //}

    export(model: FilterSearchingRegEntidadAuditoraViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/regentidadauditora/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    postGetPagedByFilter(model: FilterSearchingRegEntidadAuditoraViewModel): Observable<any> {
        return this.http.post(this.baseUrl + 'api/mantenimiento/regentidadauditora/postGetPagedByFilter', model).pipe();
    }

    //campañas

    getCampania(idEntidad: number, idCampania: number): Observable<RegCampaniaEntidadAuditoraViewModel> {
        return this.http
            .get<RegCampaniaEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/campanias/' + idEntidad + '/' + idCampania)
            .pipe();
    }

    addCampania(campania: RegCampaniaEntidadAuditoraViewModel): Observable<any> {
        return this.http.post<RegEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/postcampania', campania).pipe();
    }

    editCampania(campania: RegCampaniaEntidadAuditoraViewModel): Observable<any> {
        return this.http.put<RegCampaniaEntidadAuditoraViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/putcampania', campania).pipe();
    }

    //deleteCampania(IdRegEntidadAuditora: number, IdCampania: number): Observable<any> {
    //    return this.http
    //        .delete<RegCampaniaEntidadAuditoraViewModel>(
    //            this.baseUrl + 'api/mantenimiento/regentidadauditora/deletecampania/' + IdRegEntidadAuditora + '/' + IdCampania,
    //        )
    //        .pipe();
    //}

    //tecnicos

    getTecnico(idTecnico: number): Observable<UsuarioViewModel> {
        return this.http.get<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/tecnicos/' + idTecnico).pipe();
    }

    addTecnico(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.post<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/posttecnico', tecnico).pipe();
    }

    getSiUsuarioExisteComoAC(tecnico: UsuarioViewModel): Observable<boolean> {
        return this.http.post<boolean>(this.baseUrl + 'api/mantenimiento/regentidadauditora/CheckSiUsuarioExisteComoACAsync', tecnico).pipe();
    }

    addTecnicoExistenteComoACyEA(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.post<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/PostUsuarioExistenteComoACyEAAsync', tecnico).pipe();
    }

    editTecnico(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.put<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/puttecnico', tecnico).pipe();
    }

    deleteTecnicoExistenteComoACyEA(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.put<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/DeleteTecnicoExistenteComoACyEAAsync', tecnico).pipe();
    }

    reactivateTecnicoExistenteComoACyEA(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.put<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regentidadauditora/ReactivateTecnicoExistenteComoACyEAAsync', tecnico).pipe();
    }

    resetFilter() {
        this.currentFilter = new FilterSearchingRegEntidadAuditoraViewModel();
    }
}
